/** TODO: Context: https://caravelo.atlassian.net/browse/CVO-18171?focusedCommentId=228621
 * At this moment it's not ready change card and retry payment for TTW.
 * Please, find a solution in this composable but in Veloair folder in order to repeat files
 * Consider use a feature flag from BE endpoint "features" or a similar approach
**/

import type { Banner } from '#layers/core/app/composables/useBanner';

const COMMON_BANNER_PROPS: Partial<Banner> = {
  global: true,
  persistent: true,
};

/**
 * Manages the global status banner based on subscription and cancellation state.
 * Subscription-level statuses (ENDED, OVERDUE, SUSPENDED) take priority over
 * cancellation statuses to reflect the most actionable state to the user.
 */
export function useSubscriptionBanner(): void {
  const { t, locale } = useI18n();
  const { setBanner, clearBanner } = useBanner();

  const subscriptionStore = useSubscriptionStore();
  const { subscriptionStatus, cancelStatus, cancellationDate, isKeepPlanOpen } = storeToRefs(subscriptionStore);

  const cancellationDateFormatted = useDateFormat(cancellationDate, { locale });

  watch(
    [subscriptionStatus, cancelStatus, cancellationDateFormatted],
    ([status, cancelSt, cancelDate]) => {
      if (!status) {
        clearBanner();
        return;
      }
      if (['OVERDUE', 'SUSPENDED'].includes(status)) {
        setBanner({
          ...COMMON_BANNER_PROPS,
          type: 'danger',
          message: t(`ui.global.status.${status.toLowerCase()}`),
        });
      } else if (['CANCELLED'].includes(status)) {
        setBanner({
          ...COMMON_BANNER_PROPS,
          type: 'warning',
          message: t(`ui.global.status.${status.toLowerCase()}`),
        });
      } else if (cancelSt === 'PENDING') {
        setBanner({
          ...COMMON_BANNER_PROPS,
          type: 'warning',
          message: t('ui.global.status.pendingCancelation', { date: cancelDate }),
          primaryAction: {
            label: t('ui.subscription.cancelPlan.keepPlan.button'),
            handler: () => {
              isKeepPlanOpen.value = true;
            },
          },
        });
      } else if (cancelSt === 'CANCELLED') {
        setBanner({
          ...COMMON_BANNER_PROPS,
          type: 'warning',
          message: t('ui.subscription.cancelPlan.cancelledInformation'),
        });
      } else {
        clearBanner();
      }
    },
    { immediate: true },
  );
}
